import { defaultColumns, defaultSort } from '../../components/sales/customerOrders/columns';

export default {
  state: {
    customerOrders: [],
    tableConfig: null,
    loading: false,
    currentPage: 1,
    filterString: null,
    sorting: {
      prop: 'created_at',
      order: 'asc',
    },
  },
  getters: {
    customerOrders: state => state.customerOrders,
    tableConfig: state => state.tableConfig,
    loading: state => state.loading,
    sorting: state => state.sorting,
    filterString: state => state.filterString,
    currentPage: state => state.currentPage,
  },
  mutations: {
    setCustomerOrders(state, customerOrders) {
      state.customerOrders = customerOrders;
    },
    setTableConfig(state, config) {
      state.tableConfig = config;
    },
    setSorting(state, sorting) {
      state.sorting = sorting;
    },
    setFilterString(state, filter) {
      state.filterString = filter;
    },
    setCurrentPage(state, currentPage) {
      state.currentPage = currentPage;
    },
    setLoading(state, loading) {
      state.loading = loading;
    },
  },
  actions: {
    async fetchTableConfig({ commit }) {
      try {
        const setting = await axios.get('api/table-settings/customer-order-list');
        const tableConfig = {
          id: setting.id || null,
          type: 'customer-order-list',
          columns: setting.id ? JSON.parse(setting.config).columns : defaultColumns,
          sort: setting.id ? JSON.parse(setting.config).sort : defaultSort,
        };
        commit('setTableConfig', tableConfig);
      } catch (e) {
      }
    },
    async fetchAll({ commit, state, dispatch }, queryString) {
      commit('setLoading', true);
      try {
        if (!state.tableConfig) {
          await dispatch('fetchTableConfig');
        }
        if (queryString) {
          commit('setFilterString', queryString.substr(1));
        } else if (queryString === '') {
          commit('setCurrentPage', 1);
          commit('setFilterString', '');
        } else {
          commit('setFilterString', state.filterString || '');
        }
        const query = `?page=${state.currentPage}&sortby=${state.sorting.prop}&sorttype=${state.sorting.order === 'ascending' ? 'asc' : 'desc'}&comparetype=${state.sorting.compareType || 'string'}&${state.filterString}`;
        const customerOrders = await axios.get('api/customer-orders' + (query || ''));
        commit('setCustomerOrders', customerOrders);
      } catch (e) {
      }
      commit('setLoading', false);
    },
    async fetch({ commit }, id) {
      return await axios.get(`api/customer-orders/${id}`);
    },
    async fetchRemainingOrders({ commit }, id) {
      return await axios.get(`api/customer-orders/remaining-orders`);
    },
    async search({ commit, state, dispatch }, queryString) {
      try {
        return await axios.get('api/customer-orders/search' + (queryString || ''));
      } catch (e) {
      }
    },
    async create({ commit }, payLoad) {
      await axios.post('api/customer-orders', payLoad);
    },
    async send({ commit }, id) {
      return await axios.post(`api/customer-orders/send/${id}`);
    },
    async update({ commit }, payLoad) {
      await axios.put('api/customer-orders', payLoad);
    },
    async cancel({ commit }, id) {
      return await axios.post(`api/customer-orders/cancel/${id}`);
    },
    async undoCancel({ commit }, id) {
      return await axios.post(`api/customer-orders/undo-cancel/${id}`);
    },
    async delete({ commit }, id) {
      await axios.delete(`api/customer-orders/${id}`);
    },
    async excelExport({ commit }, { data, fileName, fileFormat }) {
      const excel = await axios({
        url: 'api/customer-order-excel-export',
        method: 'POST',
        responseType: 'blob',
        data,
      });
      saveAs(excel, `${fileName.trim().split(' ').join('_') || 'CustomerOrders'}.${fileFormat.toLocaleLowerCase() || 'xlsx'}`);
    },
  },
};
